/**
 * Texts for Animations page - French
 * 
 * VIDEO INSTRUCTIONS:
 * Visit https://www.youtube.com/@camdiab/videos
 * Replace VIDEO_ID with actual video IDs from the CamDiab channel
 */
export const animationsPageText = {
    title: 'Animations - CamAPS FX',
    titleMeta: 'Animations CamAPS FX - Guides visuels étape par étape',
    descriptionMeta: 'Regardez de courtes animations pour répondre à quelques-unes des questions les plus courantes de CamDiab sur l\'utilisation de l\'application CamAPS FX.',
    keywords:
        'animations camaps fx, tutoriels camaps, tutoriels application diabète, animations pompe insuline, tutoriels cgm',
    localeMeta: 'fr_ch',

    mainHeader: 'Animations',
    mainSubHeader: 'Courtes animations pour répondre à quelques-unes des questions les plus courantes de CamDiab.',

    altHelp: 'Aide',
    altInfo: 'Info',
    altAppStore: 'Télécharger sur l\'App Store',
    altGooglePlay: 'Disponible sur Google Play',
    ariaGoToSlide: 'Aller à la diapositive {n}',
    ariaNextSlide: 'Diapositive suivante',
    ariaPrevSlide: 'Diapositive précédente',
    videoNotSupportedText: 'Votre navigateur ne prend pas en charge la balise vidéo.',
    virtualModeTooltipText: 'Le mode virtuel vous permet d\'essayer l\'application sans être connecté à une vraie pompe à insuline et à un capteur CGM.',
    closeButtonText: 'Fermer',
    sortPopular: 'Les plus populaires',
    sortAZ: 'A-Z',
    sortOldest: 'Les plus anciens',
    sortNewest: 'Les plus récents',
    filterDana: 'Dana',
    filterYpsoPump: 'YpsoPump',
    filterAll: 'Tous',
    // Getting Started Section
    gettingStartedHeader: 'Prêt à commencer?',
    step1Title: '<strong>Étape 1:</strong> Téléchargez l\'application',
    step2Title: '<strong>Étape 2:</strong> Créez un compte',
    step3Title: '<strong>Étape 3:</strong> Commencez la formation essentielle dans l\'application',
    step4Title: '<strong>&#201;tape 4:</strong> Associez la pompe et le CGM de votre choix (avec l\'approbation de votre &eacute;quipe soignante) ou explorez l\'application avec le <strong>Mode Virtuel</strong>',

    // Support Section
    supportSectionTitle: 'Besoin d\'aide supplémentaire?',
    supportSectionText: 'Notre équipe d\'assistance est là pour répondre à vos questions.',
    supportButtonText: 'CONTACTER LE SUPPORT',

    // Additional Resources Section
    additionalResourcesTitle: 'Ressources supplémentaires',
    additionalResourcesSubtitle: 'Découvrez d\'autres façons d\'en savoir plus sur CamAPS FX',
    
    userTrainingTitle: 'Formation des utilisateurs',
    userTrainingDescription: 'Matériel de formation complet pour débuter avec CamAPS FX.',
    userTrainingLink: '/user-training',
    
    webinarsTitle: 'Webinaires',
    webinarsDescription: 'Rejoignez nos webinaires en direct et sessions enregistrées.',
    webinarsLink: '#',
    
    factsheetsTitle: 'Fiches d\'information',
    factsheetsDescription: 'Téléchargez des fiches d\'information et des guides utiles.',
    factsheetsLink: '#',

    videos: [
        // {
        //     id: 1,
        //     title: 'Getting Started with YpsoPump',
        //     description: 'Learn how to set up your YpsoPump with CamAPS FX.',
        //     date: '15 Dec 2024',
        //     duration: '5:24',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_1 with actual video ID from @camdiab channel
        //     views: 5420
        // },
        // {
        //     id: 2,
        //     title: 'Dana Pump Setup Guide',
        //     description: 'Step-by-step guide for Dana pump configuration.',
        //     date: '10 Dec 2024',
        //     duration: '7:15',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_2 with actual video ID from @camdiab channel
        //     views: 8950
        // },
        // {
        //     id: 3,
        //     title: 'Understanding Your CGM Data',
        //     description: 'Learn how to interpret your glucose readings.',
        //     date: '5 Dec 2024',
        //     duration: '4:33',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_3 with actual video ID from @camdiab channel
        //     views: 12340
        // },
        // {
        //     id: 4,
        //     title: 'YpsoPump Advanced Features',
        //     description: 'Explore advanced settings and customization.',
        //     date: '1 Dec 2024',
        //     duration: '6:48',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_4 with actual video ID from @camdiab channel
        //     views: 3210
        // },
        // {
        //     id: 5,
        //     title: 'Dana Pump Troubleshooting',
        //     description: 'Common issues and solutions for Dana pump.',
        //     date: '28 Nov 2024',
        //     duration: '5:12',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_5 with actual video ID from @camdiab channel
        //     views: 6780
        // },
        // {
        //     id: 6,
        //     title: 'Managing Meal Boluses',
        //     description: 'Best practices for meal-time insulin delivery.',
        //     date: '25 Nov 2024',
        //     duration: '8:05',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_6 with actual video ID from @camdiab channel
        //     views: 9450
        // },
        // {
        //     id: 7,
        //     title: 'YpsoPump Battery Management',
        //     description: 'Tips for extending battery life and replacement.',
        //     date: '20 Nov 2024',
        //     duration: '3:27',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_7 with actual video ID from @camdiab channel
        //     views: 4120
        // },
        // {
        //     id: 8,
        //     title: 'Dana Pump Cartridge Change',
        //     description: 'How to safely change your insulin cartridge.',
        //     date: '15 Nov 2024',
        //     duration: '4:55',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_8 with actual video ID from @camdiab channel
        //     views: 7230
        // },
        // {
        //     id: 9,
        //     title: 'Exercise Mode Setup',
        //     description: 'Configure settings for physical activity.',
        //     date: '10 Nov 2024',
        //     duration: '6:18',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_9 with actual video ID from @camdiab channel
        //     views: 10560
        // },
        // {
        //     id: 10,
        //     title: 'YpsoPump Alerts & Notifications',
        //     description: 'Customize your pump alerts and alarms.',
        //     date: '5 Nov 2024',
        //     duration: '5:41',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'ypso',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_10 with actual video ID from @camdiab channel
        //     views: 5890
        // },
        // {
        //     id: 11,
        //     title: 'Dana Pump Connectivity',
        //     description: 'Bluetooth pairing and connection tips.',
        //     date: '1 Nov 2024',
        //     duration: '7:52',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'dana',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_11 with actual video ID from @camdiab channel
        //     views: 8120
        // },
        // {
        //     id: 12,
        //     title: 'Night Time Settings',
        //     description: 'Optimize your settings for better sleep.',
        //     date: "18 Apr 2016",
        //     duration: '6:03',
        //     thumbnail: '/images/video-placeholder.svg',
        //     category: 'all',
        //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_12 with actual video ID from @camdiab channel
        //     views: 11230
        // }
    {
      id: 1,
      title: "Ajuster les taille de repas préétablies",
      description: "Ajuster les taille de repas préétablies",
      date: "11 Apr 2025",
      duration: "0:44",
      category: "ypso",
      videoUrl: "https://youtu.be/rmEIIODQ3Zw",
    },
    {
      id: 2,
      title: "Administration d'un bolus repas",
      description: "Administration d'un bolus repas",
      date: "9 Oct 2026",
      duration: "1:05",
      category: "ypso",
      videoUrl: "https://youtu.be/pNOEpQ3u-vA",
    },
    {
      id: 3,
      title: "Calibration du capteur - mmol/L",
      description: "Calibration du capteur - mmol/L",
      date: "11 Apr 2025",
      duration: "2:26",
      category: "ypso",
      videoUrl: "https://youtu.be/prff1yQI-6A",
    },
    {
      id: 4,
      title: "CamAPS Companion",
      description: "CamAPS Companion",
      date: "8 Sep 2025",
      duration: "2:51",
      category: "ypso",
      videoUrl: "https://youtu.be/oQFm7uPeZDs",
    },
    {
      id: 5,
      title: "CamAPS Liberty",
      description: "CamAPS Liberty",
      date: "26 Aug 2026",
      duration: "3:41",
      category: "ypso",
      videoUrl: "https://youtu.be/eAizytmLdwE",
    },
    {
      id: 6,
      title: "Modification des unités de glucides",
      description: "Modification des unités de glucides",
      date: "11 Apr 2025",
      duration: "0:55",
      category: "ypso",
      videoUrl: "https://youtu.be/QoRfjU--F3Q",
    },
    {
      id: 7,
      title: "Poids Corporel",
      description: "Poids Corporel",
      date: "3 Mar 2026",
      duration: "1:22",
      category: "ypso",
      videoUrl: "https://youtu.be/RMOu7Yf4tF8",
    },
    {
      id: 8,
      title: "Dose Totale Quotidienne - DTQ",
      description: "Dose Totale Quotidienne - DTQ",
      date: "3 Mar 2026",
      duration: "1:29",
      category: "ypso",
      videoUrl: "https://youtu.be/jBC21Di_pzU",
    },
    {
      id: 9,
      title: "Administration d'un bolus de correction manuel",
      description: "Administration d'un bolus de correction manuel",
      date: "11 Apr 2025",
      duration: "2:08",
      category: "ypso",
      videoUrl: "https://youtu.be/Pv0J4MOAKj0",
    },
    {
      id: 10,
      title: "Comment CamAPS FX assure-t-il l'administration d'insuline ?",
      description:
        "Comment CamAPS FX assure-t-il l'administration d'insuline ?",
      date: "11 Apr 2025",
      duration: "3:37",
      category: "ypso",
      videoUrl: "https://youtu.be/BEv2Ne8N_xM",
    },
    {
      id: 11,
      title: "Comment l'algorithme CamAPS FX apprend-il ?",
      description: "Comment l'algorithme CamAPS FX apprend-il ?",
      date: "11 Apr 2025",
      duration: "4:34",
      category: "ypso",
      videoUrl: "https://youtu.be/BopFbjGAdYg",
    },
    {
      id: 12,
      title: "Gérer l'activité physique",
      description: "Gérer l'activité physique",
      date: "11 Aug 2025",
      duration: "6:27",
      category: "ypso",
      videoUrl: "https://youtu.be/yZcuaK6EdGA",
    },
    {
      id: 13,
      title: "Naviguer dans l'application",
      description: "Naviguer dans l'application",
      date: "9 Oct 2026",
      duration: "3:29",
      category: "ypso",
      videoUrl: "https://youtu.be/q55R2QdTMGg",
    },
    {
      id: 14,
      title: "Appairage de la pompe et du capteur",
      description: "Appairage de la pompe et du capteur",
      date: "3 Mar 2026",
      duration: "1:41",
      category: "ypso",
      videoUrl: "https://youtu.be/OfUMjObH5vk",
    },
    {
      id: 15,
      title: "Réglage Des Alertes - Android mmol/L",
      description: "Réglage Des Alertes - Android mmol/L",
      date: "11 Apr 2025",
      duration: "3:09",
      category: "ypso",
      videoUrl: "https://youtu.be/V3IJBpAnjO0",
    },
    {
      id: 16,
      title: "Réglage Des Alertes - iOS mmol/L",
      description: "Réglage Des Alertes - iOS mmol/L",
      date: "20 May 2025",
      duration: "3:01",
      category: "ypso",
      videoUrl: "https://youtu.be/ld-O_Tmimmk",
    },
    {
      id: 17,
      title: "Définir une cible personnalisée de glucose - mmol/L",
      description: "Définir une cible personnalisée de glucose - mmol/L",
      date: "17 Apr 2025",
      duration: "4:05",
      category: "ypso",
      videoUrl: "https://www.youtube.com/watch?v=v9L6KXmZVYE",
    },
    {
      id: 18,
      title: "Configuration du calculateur de bolus - mmol/L",
      description: "Configuration du calculateur de bolus - mmol/L",
      date: "9 Oct 2026",
      duration: "3:59",
      category: "ypso",
      videoUrl: "https://youtu.be/6vL7FkzqDGw",
    },
    {
      id: 19,
      title: "Partage des données sur le diabète - Android",
      description: "Partage des données sur le diabète - Android",
      date: "11 Apr 2025",
      duration: "3:15",
      category: "ypso",
      videoUrl: "https://youtu.be/zDCHZt1aNYA",
    },
    {
      id: 20,
      title: "Partage des données sur le diabète - iOS",
      description: "Partage des données sur le diabète - iOS",
      date: "8 Sep 2025",
      duration: "2:32",
      category: "ypso",
      videoUrl: "https://youtu.be/7RPGEZWWY1Q",
    },
    {
      id: 21,
      title: "Conseils techniques principaux - Android",
      description: "Conseils techniques principaux - Android",
      date: "11 Apr 2025",
      duration: "3:38",
      category: "ypso",
      videoUrl: "https://youtu.be/yVnA4azK3Uk",
    },
    {
      id: 22,
      title: "Conseils techniques principaux - iOS",
      description: "Conseils techniques principaux - iOS",
      date: "20 May 2025",
      duration: "3:32",
      category: "ypso",
      videoUrl: "https://youtu.be/LD7j47F18LA",
    },
    {
      id: 23,
      title: "Utiliser Ajouter un repas",
      description: "Utiliser Ajouter un repas",
      date: "11 Apr 2025",
      duration: "4:17",
      category: "ypso",
      videoUrl: "https://youtu.be/q4dcM_mKs7g",
    },
    {
      id: 24,
      title: "Utilisation de l'Auto mode",
      description: "Utilisation de l'Auto mode",
      date: "9 Oct 2026",
      duration: "2:56",
      category: "ypso",
      videoUrl: "https://youtu.be/J04r76ceCLQ",
    },
    {
      id: 25,
      title: "Utilisation de la fonction Blocage",
      description: "Utilisation de la fonction Blocage",
      date: "11 Apr 2025",
      duration: "1:43",
      category: "ypso",
      videoUrl: "https://youtu.be/kLCO8Ra1wwA",
    },
    {
      id: 26,
      title: "Utiliser Boost",
      description: "Utiliser Boost",
      date: "11 Apr 2025",
      duration: "2:26",
      category: "ypso",
      videoUrl: "https://youtu.be/aWAnePDMcXg",
    },
    {
      id: 27,
      title: "Utiliser Ease-off",
      description: "Utiliser Ease-off",
      date: "11 Apr 2025",
      duration: "3:50",
      category: "ypso",
      videoUrl: "https://youtu.be/Ty43Aks_Gs8",
    },
    {
      id: 28,
      title: "Qu'est-ce qu'une impulsion de perméabilité ? - mmol/L",
      description: "Qu'est-ce qu'une impulsion de perméabilité ? - mmol/L",
      date: "11 Apr 2025",
      duration: "3:14",
      category: "ypso",
      videoUrl: "https://youtu.be/x4YHXsqgZzk",
    },
    {
      id: 29,
      title: "Voyager avec CamAPS FX",
      description: "Voyager avec CamAPS FX",
      date: "9 Oct 2026",
      duration: "3:12",
      category: "ypso",
      videoUrl: "https://youtu.be/YcwMeQqYEh4",
    },
    {
      id: 30,
      title: "Comprendre les taux de glucose élevés et bas - mmol/L",
      description: "Comprendre les taux de glucose élevés et bas - mmol/L",
      date: "9 Oct 2026",
      duration: "5:31",
      category: "ypso",
      videoUrl: "https://youtu.be/afIOV8M8P_c",
    },
  ],
};
